.root {
  margin-bottom: clamp(var(--space-28), 3.5vw, var(--space-48));
}

.title {
  font-family: var(--font-heading);
  font-size: var(--type-project);
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
  line-height: 1.15;
  text-wrap: balance;
  color: var(--color-text);
  padding-bottom: clamp(var(--space-16), 2vw, var(--space-24));
  margin-bottom: clamp(var(--space-16), 2vw, var(--space-24));
  border-bottom: 1px solid var(--color-border);
}

.steps {
  display: grid;
  gap: var(--space-8);
  max-width: 68ch;
  padding-left: var(--space-20);
  font-size: 1rem;
  line-height: 1.6;
  color: var(--color-text);

  li::marker {
    font-weight: 700;
    color: var(--color-text-muted);
  }
}
